export default "//file.bilionpass.com/japandx-web/0.0.1/static/num_02.2a5d1f8a-ae0207.svg";